// extracted by mini-css-extract-plugin
module.exports = {"updateAvailableTag":"CriteriaViewUpdateComponent_updateAvailableTag_3_6dj","spinAround":"CriteriaViewUpdateComponent_spinAround_10vUi"};